/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/**
 * EnabledPaymentsForOBO enum.
 */
 export enum EnabledPaymentsForOBO {
    OnCustomerAccount = 1,
    ExpressPayment = 0,
    Loyalty = 0,
    GiftCard = 0,
    PaymentInstrument = 0,
    ApplePay = 0
}
